export default {"src":"/_next/static/media/register_corner_image.3cc28b3b.svg","height":270,"width":244};